import Header from './header';
import Footer from '@/components/layouts/footer';

import dynamic from 'next/dynamic';

const MobileNavigation = dynamic(() => import('./mobile-navigation'), {
  ssr: false,
});

export default function HomeLayout({
  children,
  layout,
}: React.PropsWithChildren<{ layout: string }>) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-100 transition-colors duration-150">
      <Header layout={layout} />
      <div className="min-h-screen max-w-[1560px] mx-auto w-full">
        {children}
      </div>
      <Footer />
      <MobileNavigation />
    </div>
  );
}
